module.exports = __webpack_public_path__ + "img/lotto-dl-ladl-768x219.189caac7.jpg";